// toastMessages.ts

type Entity = string;

export const Toast = {
  // ───── CRUD Success ─────────────
  createSuccess: (e: Entity) => `${e} successfully created`,
  updateSuccess: (e: Entity) => `${e} successfully updated`,
  deleteSuccess: (e: Entity) => `${e} successfully deleted`,
  saveSuccess:   (e: Entity) => `${e} successfully saved`,
  uploadSuccess: (e: Entity) => `${e} uploaded successfully`,

  // ───── CRUD / System Errors ─────
  createError: (e: Entity) => `Failed to create ${e}`,
  updateError: (e: Entity) => `Failed to update ${e}`,
  deleteError: (e: Entity) => `Failed to delete ${e}`,
  saveError:   (e: Entity) => `Failed to save ${e}`,
  fetchError:  (e: Entity) => `Failed to fetch ${e}`,
  linkError:   (e: Entity) => `Failed to link ${e}`,
  resetError:  (e: Entity) => `Error resetting ${e}`,
  uploadError: (e: Entity) => `Failed to upload ${e}`,

  // ───── Fortnox Specific Messages ─────
//   fortnoxInvalidAuth: 'Fortnox Invalid Authorization',
//   fortnoxConnectionAdded: 'Fortnox connection added successfully',
//   fortnoxConnectionResetSuccess: 'Fortnox connection reset successfully',
//   fortnoxConnectionResetError: 'Error resetting Fortnox connection',
//   fortnoxFetchAccountsError: 'Failed to fetch Fortnox accounts with categories.',
//   fortnoxLinkCategoryError: 'Failed to link category with Fortnox account.',

  // ───── Other Activity / Misc Messages ─────
  recentActivitySaved: 'Recent activity saved',
  successfullyUploaded: 'Successfully uploaded',
};


//useCase 
// ── CRUD ──
// commonToast('success', Toast.createSuccess('User'));

// // ── Fortnox ──
// commonToast('success', Toast.fortnoxConnectionAdded);

 